//Actions
import {
  COMPANY_RECENT_ACTIVITY_LIST,
  COMPANY_RECENT_ACTIVITY_LIST_SUCCESS,
  COMPANY_RECENT_ACTIVITY_LIST_FAILURE,
} from "./actionType";

//Company Recent Activity List
export const companyRecentActivityList = () => ({
  type: COMPANY_RECENT_ACTIVITY_LIST,
});

export const companyRecentActivityListSuccess = (response) => ({
  type: COMPANY_RECENT_ACTIVITY_LIST_SUCCESS,
  payload: response,
});

export const companyRecentActivityListFailure = (error) => ({
  type: COMPANY_RECENT_ACTIVITY_LIST_FAILURE,
  payload: error,
});
